import { gql } from "@apollo/client"
import { Button, Icon, Modal } from "@oysterhr/ui"
import { useTranslation } from "react-i18next"
import type { Agreement, Hiring, Maybe } from "@oysterhr/schema"

export const RegenerationInfoModal = ({
  hiring,
  onClose,
}: {
  hiring: Maybe<HiringFTECompanyRegenerationInfoModalFragment> | undefined
  onClose: () => void
}) => {
  const { t } = useTranslation("hiring_fte/RegenerationInfoModal")

  const isAutomated = Boolean(hiring?.agreements?.filter(agg => agg.isAutomated)?.length)

  if (!isAutomated) {
    return (
      <Modal isOpen onRequestClose={onClose}>
        <Modal.Header>{t("manual.title")}</Modal.Header>
        <Modal.Content>{t("manual.description")}</Modal.Content>
        <Modal.Footer>
          <Button type="button" onClick={onClose}>
            {t("manual.action")}
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }

  return (
    <Modal isOpen onRequestClose={onClose}>
      <Modal.Header>{t("automated.title")}</Modal.Header>
      <Modal.Content>
        {t("automated.description")}

        <div className="mt-4 bg-gray-100 p-4">
          <ul className="space-y-3 px-3 py-2.5">
            {hiring?.agreements?.map(agreement => (
              <li key={agreement.id} className="flex flex-row items-center">
                <Icon name="File" className="mr-2" />
                {t(`agreementTypeEnum.${agreement.agreementType}`, { ns: "Common" })}
              </li>
            ))}
          </ul>
        </div>
      </Modal.Content>
      <Modal.Footer>
        <Button type="button" onClick={onClose}>
          {t("automated.action")}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
RegenerationInfoModal.fragments = {
  hiring: gql`
    fragment HiringFTECompanyRegenerationInfoModalFragment on Hiring {
      id
      agreements {
        id
        isAutomated
        agreementType
        lastUpdate {
          timestamp
        }
      }
    }
  `,
}

export type HiringFTECompanyRegenerationInfoModalFragment = Pick<Hiring, "id"> & {
  agreements: Pick<Agreement, "id" | "agreementType" | "isAutomated" | "lastUpdate">[]
}
